var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{attrs:{"value":_vm.value && _setup.isMaximumAvailableLTV,"type":"info","transition":"scroll-y-transition","dense":""}},[_vm._v("\n  "+_vm._s(_vm.$i18n.useMortgageSimulationFormStep1.HIGH_LTV_ALERT)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }